/**
 * Routes for all available project pages
 */
export enum EnumRoutePaths {
  // Root page
  BASE = '/',
  CHECKING = '/order-checking',
  AI_SUGGESTIONS = '/ai',
  CAREGORIES = '/categories',
  CAREGORY_TOUR = '/categories/:id',
  TOUR_BOOKING = '/tour-booking',
  VIP_TOURS = '/vip-tours',
  ABOUT = '/about',
  PRIVACY = '/privacy',
  CART = '/cart',
  TAXI = '/taxi',
  RATES = '/rates',
  BLOG = '/blog',
  SINGLE_BLOG = '/blog/:id',
  REFERRER = '/referrer',
  CITY_TOURS = '/tours',
}
